/**
 * Set permissions list.
 *
 * @param state
 * @param payload
 */
export function PERMISSIONS(state, payload) {
  state.permissions = payload.data;
  state.meta = payload.meta;
}

/**
 * Set Permission.
 *
 * @param state
 * @param payload
 */
export function PERMISSION(state, payload) {
  state.permission = payload.data;
}